<template>
  <van-sticky>
    <div class="hScaffoldParentDiv">
      <van-nav-bar v-if="!hideNav"
                   :border="false"
                   :style="{
              backgroundColor: bg ? bg : HNewGameUIConfig.newGameUIType === 1
                ?'#FFE88A'
                : HNewGameUIConfig.newGameUIType === 2
                    ? '#FF7373'
                    : HNewGameUIConfig.newGameUIType === 3
                        ? '#111111'
                        : 'white'
                  }"
                   safe-area-inset-top
                   @clickLeft="onClickLeft"
                   @clickRight="rightCallback"
      >
        <template #title>
          <div :style="hcf.getTextStyle({
            addSize:3,color:HNewGameUIConfig.newGameUIType === 2 ||
                HNewGameUIConfig.newGameUIType === 3
            ? 'white'
            : 'black'
          })">{{ title }}</div>
        </template>
        <template v-if="!hideLeftBackBtn" #left>
          <van-icon name="arrow-left" size="21" :color="HNewGameUIConfig.newGameUIType === 2 ||
                HNewGameUIConfig.newGameUIType === 3
            ? 'white'
            : 'black'"/>
        </template>
        <template v-if="rightText!==''" #right>
          <div :style="hcf.getTextStyle({
          addSize:1,color:HNewGameUIConfig.newGameUIType ===1?'#111':HNewGameUIConfig.newGameUIType ===2? 'white':'main'
         })">{{ rightText }}</div>
        </template>
        <template v-if="rightText===''" #right>
          <slot name="customRight"/>
        </template>
      </van-nav-bar>
      <slot name="header"/>
    </div>
  </van-sticky>
  <div class="contentStyle">
    <div class="hScaffoldContent" :class="{ hScaffoldContentAlignHeader: desktopAlignHeader, hScaffoldContentFull: desktopFull }">
      <slot/>
    </div>
  </div>
</template>


<script setup>
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {hr} from "@/components/utils/HRouter.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  defineProps(
      {
        title: {
          type: String,
          default: ''

        },
        rightText: {
          type: String,
          default: ''
        },
        customRight: {
          default: false,
        },
        hideNav: {
          default: false
        },
        rightCallback: Function,
        hideLeftBackBtn: {
          default: false,
        },
        bg: {
          type: String,
          default: ''
        },
        // 桌面: 内容默认居中限宽 --pc-scaffold-w; 置 true 时改为铺满 .pc-container 并对齐顶部
        // Header 的 logo 左缘 / 金额右缘(供福利 tab 内嵌的返水页与 tab 行/VIP 页对齐)。
        desktopAlignHeader: {
          type: Boolean,
          default: false
        },
        // 桌面: 放开限宽并 100% 铺满父容器(不自缩)。用于父级已负责左右内缩的场景
        // (如充值 tab: PayWithdraw 根节点已加内缩, nav 与内容都只需铺满 → 左右缘必然一致)。
        desktopFull: {
          type: Boolean,
          default: false
        }
      });

  function onClickLeft() {
    hr.goBack();
  }
</script>


<style scoped>
  .contentStyle {
    width: 100%;
    /*tabbar 高度*/
    height: calc(100% - 46px);
    /* body 已锁 viewport, 各页内容改为容器内部滚动 */
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  /* 移动端: 内容包裹层透明无约束(等同原来直接放 slot); 桌面在下方 @media 里居中定宽 */
  .hScaffoldContent {
    width: 100%;
  }

  .hScaffoldParentDiv {
    display: flex;
    flex-direction: column;
  }

  /* 桌面: 所有基于 HScaffold 的独立内页统一居中定宽, 两侧留白露出页面底色。
     一处改动覆盖全部内页。宽度用 --pc-scaffold-w(desktop.css 定义), 个别页可另行覆盖。 */
  @media (min-width: 1024px) {
    .contentStyle {
      background: var(--pc-page-bg);
      /* 基础规则的 height:calc(100% - 46px) 里的 46px 会被 postcss 转成 vw, 宽屏下放大到 ~245px,
         使内容区比视口矮一大截、底部露出大片灰色空白。@media 内 px 不转换, 用真实 46px(顶部 nav 高)
         还原, 让内容区正好填满 nav 下方到视口底部。独立详情页(内容区在视口内定高滚动)因此不再留白。 */
      height: calc(100% - 46px);
      /* 桌面: 放开滚动链, 让内层详情(如 HSwiperLR 固定高容器)到边后滚轮能传递到外层整页,
         露出被固定高度挡在视口下方的内容(否则会"滑不动看不全底部")。 */
      overscroll-behavior: auto;
    }
    .hScaffoldContent {
      max-width: var(--pc-scaffold-w);
      margin: 0 auto;
      background: var(--ct-main-container-bg-color, #fff);
      min-height: 100%;
    }

    /* 内嵌于福利/充值 tab 的内页: 放开限宽, 对齐 Header 的 logo 左缘/金额右缘。
       用 margin(而非 padding)做内缩 —— 本元素自带白色背景, padding 不会缩小背景绘制范围,
       会导致白块比同样内缩的标题行(充值/提现、支付方式)更宽 8px; 用 margin 缩小元素盒本身,
       白背景随之收窄, 与标题行左右缘完全一致。放在基础规则之后, 同特异性下覆盖 max-width/margin。 */
    .hScaffoldContentAlignHeader {
      max-width: none;
      margin-left: var(--pc-content-inset-x);
      margin-right: var(--pc-content-inset-x);
    }

    /* 铺满父容器、不自缩(左右内缩交给父级)。父级 padding 已定边界, 这里 100% 填满即与
       同父级下的其它块(如充值/提现 nav)左右缘完全一致。 */
    .hScaffoldContentFull {
      max-width: none;
      margin: 0;
    }
  }
</style>
